<ng-container *ngIf="formControl; then formDatepicker; else simpleDatepicker"></ng-container>

<ng-template #formDatepicker>
  <mat-form-field>
    <mat-label class="label">{{label}}</mat-label>
    <input matInput
           [matDatepicker]="datepicker"
           [formControl]="formControl"
           [placeholder]="placeholder"
           [max]="maxDate"
           [min]="minDate"
           [required]="required ? '' : null"
           [readonly]="true"
           [matDatepickerFilter]="dateFilterFn"
           (focus)="datepicker.open()"
           (click)="datepicker.open()"
           (dateChange)="onDateChange($event)">
    <mat-datepicker-toggle matSuffix [for]="datepicker"></mat-datepicker-toggle>
    <mat-datepicker [touchUi]="screenWidth <= 992" #datepicker [startView]="startView"></mat-datepicker>
    <mat-icon *ngIf="value && showClear" matSuffix class="clear-icon" (click)="onClearDate($event)">clear</mat-icon>
  </mat-form-field>
  <app-form-error-list
      *ngIf="showValidations"
      [errorMap]="formControl.errors">
  </app-form-error-list>
</ng-template>

<ng-template #simpleDatepicker>
  <mat-form-field>
    <mat-label class="label">{{label}}</mat-label>
    <input matInput
           [matDatepicker]="datepicker"
           [value]="value"
           [placeholder]="placeholder"
           [max]="maxDate"
           [min]="minDate"
           [required]="required ? '' : null"
           [readonly]="true"
           [matDatepickerFilter]="dateFilterFn"
           (focus)="datepicker.open()"
           (click)="datepicker.open()"
           (dateChange)="onDateChange($event)"
           [disabled]="isDisabled">
    <mat-datepicker-toggle matSuffix [for]="datepicker"></mat-datepicker-toggle>
    <mat-datepicker [touchUi]="screenWidth <= 992" #datepicker [startView]="startView"></mat-datepicker>
    <mat-icon *ngIf="value && showClear" matSuffix class="clear-icon" (click)="onClearDate($event)">clear</mat-icon>
  </mat-form-field>
</ng-template>
